import { createContext } from "react";
import { initialPointerCoordinates } from "../init";

const PointerCoordinatesContext = createContext(initialPointerCoordinates);

export default PointerCoordinatesContext;
